import React from 'react';
import { Plus, Trash2, Utensils, ChevronUp, ChevronDown } from 'lucide-react';

const DEFAULT_COURSES = ['Antipasto', 'Primo', 'Secondo', 'Dolce', 'Brindisi di Mezzanotte'];
const gold = '#fbbf24';

export function CapodannoMenuEditor({ menu, onChange }) {
  const m = menu || { published: false, courses: [], notes: '' };
  const courses = m.courses || [];
  const set = patch => onChange({ ...m, ...patch });
  const setCourse = (i, patch) => set({ courses: courses.map((c, idx) => (idx === i ? { ...c, ...patch } : c)) });
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= courses.length) return;
    const arr = [...courses];
    [arr[i], arr[j]] = [arr[j], arr[i]];
    set({ courses: arr });
  };

  return (
    <div className="rounded-xl p-4 space-y-3" data-testid="capodanno-menu-editor"
      style={{ background: 'rgba(251,191,36,0.05)', border: '1px solid rgba(251,191,36,0.35)' }}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Utensils size={16} style={{ color: gold }} />
          <span className="font-manrope font-700 text-sm" style={{ color: gold }}>Menu della Cena</span>
        </div>
        <label className="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" checked={!!m.published} data-testid="menu-published-toggle"
            onChange={e => set({ published: e.target.checked })} className="w-4 h-4" style={{ accentColor: gold }} />
          <span className="font-manrope text-xs" style={{ color: m.published ? '#86efac' : '#9ca3af' }}>
            {m.published ? 'Pubblicato sul sito' : 'Bozza (mostra "Menu svelato a breve")'}
          </span>
        </label>
      </div>

      {courses.length === 0 && (
        <button type="button" data-testid="menu-use-template"
          onClick={() => set({ courses: DEFAULT_COURSES.map(name => ({ name, dishes: '' })) })}
          className="w-full py-2.5 rounded-lg font-manrope font-600 text-xs"
          style={{ border: '1px dashed rgba(251,191,36,0.4)', color: gold }}>
          Usa struttura classica (Antipasto, Primo, Secondo, Dolce, Brindisi)
        </button>
      )}

      {courses.map((c, i) => (
        <div key={i} className="rounded-lg p-3 space-y-2" style={{ background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.06)' }}>
          <div className="flex items-center gap-2">
            <input value={c.name} placeholder="Nome portata (es. Antipasto)" data-testid={`menu-course-name-${i}`}
              onChange={e => setCourse(i, { name: e.target.value })}
              className="input-elegant text-sm flex-1" style={{ height: '34px' }} />
            <button type="button" onClick={() => move(i, -1)} className="text-gray-500 hover:text-white" data-testid={`menu-course-up-${i}`}><ChevronUp size={15} /></button>
            <button type="button" onClick={() => move(i, 1)} className="text-gray-500 hover:text-white" data-testid={`menu-course-down-${i}`}><ChevronDown size={15} /></button>
            <button type="button" onClick={() => set({ courses: courses.filter((_, idx) => idx !== i) })}
              className="text-gray-600 hover:text-red-400" data-testid={`menu-course-remove-${i}`}><Trash2 size={15} /></button>
          </div>
          <textarea value={c.dishes} rows={3} placeholder="Un piatto per riga" data-testid={`menu-course-dishes-${i}`}
            onChange={e => setCourse(i, { dishes: e.target.value })}
            className="input-elegant text-sm w-full" style={{ minHeight: '72px', resize: 'vertical' }} />
        </div>
      ))}

      <button type="button" data-testid="menu-add-course"
        onClick={() => set({ courses: [...courses, { name: '', dishes: '' }] })}
        className="flex items-center gap-2 text-sm font-manrope font-600 py-1" style={{ color: gold }}>
        <Plus size={15} /> Aggiungi portata
      </button>

      <div>
        <label className="block text-xs font-manrope font-600 text-gray-400 mb-1">Note allergie / diete (opzionale)</label>
        <textarea value={m.notes || ''} rows={2} data-testid="menu-notes"
          placeholder="Es. Disponibili alternative vegetariane e senza glutine su richiesta"
          onChange={e => set({ notes: e.target.value })}
          className="input-elegant text-sm w-full" style={{ minHeight: '56px', resize: 'vertical' }} />
      </div>
    </div>
  );
}
